<template>
  <van-tabs
    v-model:active="active"
    :style="{ height: clientHeight - 80 + 'px' }"
    color="#3ca7f0"
  >
    <van-tab
      :title="
        tools.GetLanguageValue('public.app.购物车') +
        '(' +
        Carts.TableName +
        ')'
      "
    >
      <div
        class="cart_content"
        v-if="Carts.Items.length > 0"
        :style="{ height: clientHeight - 150 + 'px' }"
      >
        <div>
          <div v-for="(item, index) in Carts.Items" :key="index">
            <div
              style="border-bottom: 1px solid #eee; width: 100%; display: flex"
              v-if="item.IsPrecedence"
            >
              <div style="width: 50px; text-align: center">
                <van-icon
                  name="descending"
                  size="18pt"
                  color="#1e1e1e"
                  @click="ExcludePrecedence(item)"
                />
              </div>
              <div style="font-size: 11pt; color: #555555">
                {{ item.Count }} ✖ {{ item.Name }}
              </div>
            </div>

            <div v-if="item.ProductType == 200">
              <div v-for="items in item.CollectionItems" :key="items.Id">
                <div
                  style="
                    border-bottom: 1px solid #eee;
                    width: 100%;
                    display: flex;
                  "
                  v-if="items.IsPrecedence"
                >
                  <div style="width: 50px; text-align: center">
                    <van-icon
                      name="descending"
                      size="18pt"
                      color="#1e1e1e"
                      @click="ExcludePrecedence(items)"
                    />
                  </div>
                  <div style="font-size: 11pt; color: #555555">
                    {{ items.Count }} ✖ {{ items.Name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="cart_items">
          <div
            v-for="(item, index) in Carts.Items"
            :key="index"
            style="border-bottom: 1px solid #eee"
          >
            <div class="cart_item">
              <div class="item_opt" v-if="item.ProductType != 200">
                <van-icon
                  name="delete-o"
                  :size="22"
                  @click="MinusCartItem(item)"
                />
              </div>
              <div class="item_detail">{{ item.Count }} ✖ {{ item.Name }}</div>
              <div class="item_detail_btn">
                <van-icon name="edit" size="18px" @click="DetailOrder(item)" />
              </div>
              <div class="item_amount" v-if="item.ProductType == 100">
                <div>
                  <span>
                    {{ item.TotalFormat }}
                  </span>
                  <span style="padding: 5px 0px">
                    <!-- <van-icon size="22" name="flag-o" @click="AddPrecedence(item)" /> -->
                  </span>
                </div>
              </div>
            </div>
            <div>
              <AttributeParamsMouduleSimple
                @update="
                  (a) => {
                    this.GetShoppingCartComplete();
                  }
                "
                :Model="item"
                :key="item"
              />
            </div>
            <div class="cart_items_gengduo" v-if="item.ProductType == 200">
              <div class="productCollection_content">
                <div
                  class="productCollection_items_botton"
                  v-for="(item, index) in item.CollectionItems"
                  :key="item.Id"
                >
                  <div class="productCollection_items">
                    <div class="productCollection_index">
                      <!-- <van-icon size="22" name="flag-o" @click="AddPrecedence(item)" /> -->
                      {{ index + 1 }}
                    </div>
                    <div
                      class="productCollection_name"
                      @click="DetailOrder(item)"
                    >
                      <van-icon name="edit" :size="18" />
                      {{ item.Name }}
                    </div>
                    <div class="productCollection_count">{{ item.Count }}</div>
                    <div class="productCollection_manage">
                      <van-icon
                        name="delete-o"
                        :size="18"
                        @click="MinusCartItem(item)"
                      />
                    </div>
                  </div>
                  <AttributeParamsMouduleSimple
                    :Model="item"
                    :key="item.Id"
                    style="width: 100%"
                  />
                </div>
              </div>
              <div class="edit_content">
                <van-button
                  icon="shopping-cart-o"
                  type="default"
                  @click="editCollection(item)"
                  size="small"
                >
                  {{ tools.GetLanguageValue("public.app.新增") }}
                </van-button>
              </div>
            </div>
            <div
              class="cart_items_gengduo"
              v-if="item.ProductType == 500 || item.ProductType == 400"
            >
              <div class="productCollection_content">
                <div
                  class="productCollection_items_botton"
                  v-for="(item, index) in item.CollectionItems"
                  :key="item.Id"
                >
                  <div class="productCollection_items">
                    <div class="productCollection_index">
                      <!-- <van-icon size="22" name="flag-o" @click="AddPrecedence(item)" /> -->
                      {{ index + 1 }}
                    </div>
                    <div
                      class="productCollection_name"
                      @click="DetailOrder(item)"
                    >
                      <van-icon name="orders-o" />{{ item.Name }}
                    </div>
                    <div class="productCollection_count">{{ item.Count }}</div>
                    <!-- <div class="productCollection_manage">
                      <van-icon name="delete-o" :size="18" @click="MinusCartItem(item)" />
                    </div> -->
                  </div>
                  <AttributeParamsMouduleSimple :Model="item" :key="item.Id" />
                </div>
              </div>
              <!-- <div class="edit_content">
                <van-button
                  icon="shopping-cart-o"
                  type="default"
                  @click="editCollection(item)"
                  size="small"
                >
                  {{ tools.GetLanguageValue("public.app.新增") }}
                </van-button>
              </div>-->
            </div>
          </div>
        </div>
      </div>

      <!-- 下单信息 -->
      <div class="cart_total_content">
        <div class="cart_total_title" v-if="UserInfo.AccountType == 100"></div>
      </div>

      <!-- 空购物车提示 -->
      <div class="cart_tips" v-if="Carts.Items.length == 0">
        <p>
          <svg
            t="1659185225274"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3480"
            width="200"
            height="200"
          >
            <path
              d="M734.208 354.461538a78.769231 78.769231 0 0 1 73.216 49.703385L866.461538 552.881231V787.692308a78.769231 78.769231 0 0 1-78.76923 78.76923H236.307692a78.769231 78.769231 0 0 1-78.76923-78.76923v-231.699693l59.195076-151.433846A78.769231 78.769231 0 0 1 290.107077 354.461538h444.100923z m-355.209846 212.676924H189.046154L189.046154 787.692308a47.261538 47.261538 0 0 0 42.417231 47.02523L236.307692 834.953846h551.384616a47.261538 47.261538 0 0 0 47.02523-42.417231L834.953846 787.692308v-220.553846h-189.952a133.907692 133.907692 0 0 1-266.003692 0z m355.249231-181.169231H290.067692a47.261538 47.261538 0 0 0-41.865846 25.284923l-2.166154 4.765538L199.286154 535.630769h190.306461l-0.039384 0.590769A15.753846 15.753846 0 0 1 409.6 551.384615a102.4 102.4 0 0 0 204.8 0 15.753846 15.753846 0 0 1 14.848-15.753846h196.450462l-47.576616-119.847384a47.261538 47.261538 0 0 0-38.675692-29.538462l-5.238154-0.275692zM286.168615 106.417231l2.166154 2.363077 114.609231 155.254154a15.753846 15.753846 0 0 1-23.158154 21.070769l-2.166154-2.363077-114.60923-155.214769a15.753846 15.753846 0 0 1 23.158153-21.110154z m244.460308-4.017231a15.753846 15.753846 0 0 1 15.438769 12.603077l0.315077 3.150769v155.254154a15.753846 15.753846 0 0 1-31.192615 3.150769l-0.315077-3.150769V118.153846c0-8.664615 7.049846-15.753846 15.753846-15.753846z m265.688615 3.072a15.753846 15.753846 0 0 1 4.962462 19.298462l-1.614769 2.756923-114.333539 155.175384a15.753846 15.753846 0 0 1-26.978461-15.911384l1.575384-2.756923 114.372923-155.21477a15.753846 15.753846 0 0 1 22.016-3.347692z"
              fill="#dbdbdb"
              p-id="3481"
            ></path>
          </svg>
        </p>
        <p>{{ tools.GetLanguageValue("public.app.您的购物车是空的") }}</p>
      </div>
    </van-tab>
    <van-tab :title="tools.GetLanguageValue('public.app.已下单')">
      <div
        class="cart_content"
        v-if="Carts.ItemsPlace.length > 0"
        :style="{ height: clientHeight - 200 + 'px' }"
      >
        <div class="cart_items">
          <div
            v-for="(item, index) in Carts.ItemsPlace"
            :key="index + '23698'"
            style="border-bottom: 1px solid #eee"
          >
            <div class="cart_item">
              <div class="item_opt"></div>
              <div class="item_detail_btn"></div>
              <div class="item_detail">{{ item.Name }} * {{ item.Count }}</div>
              <div
                style="width: 80px; font-size: 10pt"
                v-if="item.ProductType != 200"
              >
                <span v-if="this.IsShowOverProduct">
                  <span style="color: red">{{ item.OverCount }} </span> /{{
                    item.Count
                  }}
                </span>
                <span v-else>
                  {{ item.Count }}
                </span>
              </div>

              <div class="item_amount" v-if="item.ProductType != 200">
                {{ item.TotalFormat }}
              </div>
            </div>

            <div
              class="detail_params_items"
              v-if="item.ProductRemarkItemsOpt.length > 0"
            >
              <div
                class="detail_params_name"
                v-for="item in item.ProductRemarkItemsOpt"
                :key="item.Id"
              >
                <div>1 * {{ item.Name }} {{ item.PriceFormat }}</div>
              </div>
            </div>

            <div class="cart_items_gengduo" v-if="item.ProductType == 200">
              <div class="productCollection_content">
                <div
                  class="productCollection_items_botton"
                  v-for="(item, index) in item.CollectionItemsPlace"
                  :key="item.Id"
                >
                  <div class="productCollection_items">
                    <div class="productCollection_index">{{ index + 1 }}</div>
                    <div
                      class="productCollection_name"
                      @click="DetailOrder(item)"
                    >
                      <van-icon name="orders-o" />{{ item.Name }}
                    </div>
                    <div class="productCollection_count">
                      <span v-if="this.IsShowOverProduct">
                        <span style="color: red"> {{ item.OverCount }} </span> /
                        {{ item.Count }}
                      </span>
                      <span v-else>
                        {{ item.Count }}
                      </span>
                    </div>

                    <div class="productCollection_price">
                      {{ item.AmountFormat }}
                    </div>
                  </div>
                  <div
                    class="detail_params_items"
                    v-if="item.ProductRemarkItemsOpt.length > 0"
                  >
                    <div
                      class="detail_params_name"
                      v-for="item in item.ProductRemarkItemsOpt"
                      :key="item.Id"
                    >
                      <div>1 * {{ item.Name }} {{ item.PriceFormat }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="edit_content">
                <van-button
                  icon="shopping-cart-o"
                  type="default"
                  @click="editCollection(item)"
                  size="small"
                >
                  {{ tools.GetLanguageValue("public.app.新增") }}
                </van-button>
              </div>
            </div>
            <div
              class="cart_items_gengduo"
              v-if="
                item.ProductType == 500 ||
                (item.ProductType == 400) | (item.ProductType == 600)
              "
            >
              <div class="productCollection_content">
                <div
                  class="productCollection_items_botton"
                  v-for="(item, index) in item.CollectionItemsPlace"
                  :key="item.Id"
                >
                  <div class="productCollection_items">
                    <div class="productCollection_index">{{ index + 1 }}</div>
                    <div
                      class="productCollection_name"
                      @click="DetailOrder(item)"
                    >
                      {{ item.Name }}
                    </div>
                    <div class="productCollection_count">
                      <span v-if="this.IsShowOverProduct">
                        <span style="color: red"> {{ item.OverCount }} </span> /
                        {{ item.Count }}
                      </span>
                      <span v-else>
                        {{ item.Count }}
                      </span>
                    </div>

                    <div class="productCollection_price">
                      {{ item.AmountFormat }}
                    </div>
                  </div>
                  <p>
                    {{ item.Remarks }}
                  </p>
                  <div
                    class="detail_params_items"
                    v-if="item.ProductRemarkItemsOpt.length > 0"
                  >
                    <div
                      class="detail_params_name"
                      v-for="item in item.ProductRemarkItemsOpt"
                      :key="item.Id"
                    >
                      <div>1 * {{ item.Name }} {{ item.PriceFormat }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="edit_content" v-if="item.ProductType == 200">
                <van-button
                  icon="shopping-cart-o"
                  type="default"
                  @click="editCollection(item)"
                  size="small"
                >
                  {{ tools.GetLanguageValue("public.app.新增") }}
                </van-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 下单信息 -->
      <div class="cart_total_content">
        <div class="cart_total_title" v-if="UserInfo.AccountType == 100">
          <div>{{ tools.GetLanguageValue("public.app.桌台") }}</div>
          <div>{{ UserInfo.Name }}</div>
        </div>
        <div class="cart_plan_order"></div>
      </div>
    </van-tab>
  </van-tabs>

  <!-- 详细信息 -->
  <van-action-sheet
    v-model:show="DetailOrderWindow"
    :title="tools.GetLanguageValue('public.app.详细信息')"
  >
    <AttributeParamsMoudule :Model="CartItemOpt" :key="CartItemOpt.Id" />
  </van-action-sheet>

  <!-- 套餐信息 -->
  <van-action-sheet
    v-model:show="CollectionDetailWindow"
    :title="tools.GetLanguageValue('public.app.套餐信息')"
  >
    <StoreCartCollectionModule
      :Model="CartItemOpt"
      @GetShoppingCart="GetShoppingCartComplete()"
    />
  </van-action-sheet>
  <br />
  <br />
  <br />
  <br />

  <StoreChooseTabbar :Carts="Carts" style="z-index: 1000000" />
</template>
<script>
import StoreChooseTabbar from "../../components/tabbars/StoreChooseTabbar.vue";
import tabbar from "../../components/tabbars/storeTabbar.vue";
import addressfield from "../../components/addressfield.vue";
import paymethods from "../../components/pay-methods.vue";
import freightTransport from "../../components/freightTransport.vue";
import AttributeParamsMoudule from "../../components/AttributeParamsMoudule.vue";
import AttributeParamsMouduleSimple from "../../components/AttributeParamsMouduleSimple.vue";

import StoreCartCollectionModule from "../../components/Stores/StoreCartCollectionModule.vue";

import axios from "../../commons/AxiosMethod.js";
import commons from "../../commons/commons.js";
import tools from "../../commons/tools.js";
import { showToast, Tab, Tabs } from "vant";
import { createApp } from "vue";
import { FloatingBubble } from "vant";
export default {
  data() {
    return {
      tools: tools,
      active: "购物车",
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      Carts: {
        TableName: "",
        Items: [],
        ItemsPlace: [],
      }, // 购物车项目

      PaymenthodId: "", // 选中支付方式
      AddressId: "", // 选中支付地址
      FreightTransportId: "", // 货运地址
      Remarks: "",

      DetailOrderWindow: false, // 详细信息页面
      CartItemOpt: {
        CollectionItems: [],
      }, // 选中购物车项目

      UserInfo: {}, // 用户信息

      CollectionDetailWindow: false, // 套餐详细页面
      TableId: "",
      ShoppingCartTimer: null,
    };
  },
  name: "App",

  mounted() {
    this.TableId = localStorage.getItem("Cache-TableId");
    this.IsShowOverProduct = localStorage.getItem("IsShowOverProduct") == "yes";

    this.GetShoppingCartComplete();
  },
  components: {
    tabbar,
    addressfield,
    paymethods,
    freightTransport,
    AttributeParamsMoudule,
    StoreCartCollectionModule,
    StoreChooseTabbar,
    AttributeParamsMouduleSimple,
  },
  methods: {
    AddPrecedence(item) {
      item.IsPrecedence = true;
      this.ChangePrecedence(item);
    },
    ExcludePrecedence(item) {
      item.IsPrecedence = false;
      this.ChangePrecedence(item);
    },
    ChangePrecedence(item) {
      axios.apiMethod(
        "/Store/StoreOrder/SetPrecedence",
        "post",
        item,
        (result) => {
          if (result.Data.IsSuccess) {
            showToast(tools.GetLanguageValue("public.app.操作成功"));
            return;
          }
          showToast(result.Data.Msg);
        },
        (e) => {}
      );
    },
    // 查看套餐详细信息
    CollectionItemDetail(item) {
      this.CartItemOpt = item;
      this.CollectionDetailWindow = true;
    },
    // 详细信息
    DetailOrder(item) {
      item.CollectionItems = item.children;
      this.CartItemOpt = item;

      this.DetailOrderWindow = true;
    },
    // 编辑套餐
    editCollection(item) {
      this.$router.push({
        path: "storeCollectionItems",
        query: {
          cartId: item.Id,
          collectionId: item.ProductId,
        },
      });
    },
    // 减少商品
    MinusCartItem(item) {
      axios.apiMethod(
        "/Store/StoreOrder/CutShoppingCart",
        "post",
        { Id: item.Id },
        (result) => {
          if (result.Data.IsSuccess) {
            this.GetShoppingCartComplete();
            return;
          }
          showToast(result.Data.Msg);
        },
        (e) => {}
      );
    },
    // 获取购物车
    GetShoppingCartComplete() {
      axios.apiMethod(
        "/Store/StoreOrder/GetShoppingCart",
        "get",
        {
          TableId: this.TableId,
        },
        (result) => {
          this.Carts = result.Data;

          this.$store.commit({
            type: "updateCart",
            carts: this.Carts,
          });

          for (var i = 0; i < this.Carts.Items.length; i++) {
            if (this.Carts.Items[i].Id == this.CartItemOpt.Id) {
              this.CartItemOpt = this.Carts.Items[i];
              console.log(this.CartItemOpt.CollectionItems);
            }
          }

          // if (result.Code == 200) {
          //   tools.GetShoppingCartComplete(this.TableId);
          // } else {
          //   showToast(result.Msg);
          // }
        },
        (e) => {}
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.cart_title {
  position: fixed;
  width: 100%;
  height: 40px;
  z-index: 50000000;
}

.cart_content {
  overflow: auto;
  padding: 10px;

  .cart_items {
    background-color: #fff;
    margin: 0 auto;
    margin-top: 5px;
    border-bottom: 1px solid #eee;

    .cart_item {
      font-size: 13pt;
      margin-top: 5px;
      height: 40px;
      line-height: 40px;
      width: calc(100% - 10px);
      padding: 0px 5px;
      display: flex;
      justify-content: space-between;

      .item_opt {
        width: 20px;
        margin-right: 5px;
        text-align: center;
        height: 40px;
      }

      .item_detail {
        width: calc(100% - 90px);
        font-size: 12pt;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: left;
        font-family: Avenir, Helvetica, Arial, sans-serif;
      }

      .item_amount {
        min-width: 60px;
        text-align: right;
        font-size: 11pt;
      }
    }

    .cart_items_gengduo {
      padding: 5px;
      font-size: 9pt;

      .icon {
        font-size: 17pt !important;
      }
    }
  }
}

.cart_total_content {
  max-width: 100%;
  background-color: #fff;
  position: fixed;
  bottom: 1px;
  width: 100%;
  margin-top: 15px;
  padding: 5px;

  .cart_total_title,
  .cart_total_tax,
  .cart_total_amount {
    border-bottom: 1px solid #eee;
    padding: 5px 20px;
    display: flex;
    justify-content: space-between;
  }

  .cart_plan_order {
    text-align: center;
    margin-top: 15px;
  }
}

.content {
  min-height: 300px;

  .content_item {
    .content_item_title {
      width: calc(100% - 100px);
      margin-left: 20px;
      font-size: 15pt;

      .manage {
        font-size: 15pt;
        color: #666;
        float: right;
      }
    }
  }
}

.cart_tips {
  position: fixed;
  top: 200px;
  width: 100%;
  text-align: center;

  .cart_tips_icon {
    font-size: 17pt;
  }
}

.edit_content {
  text-align: right;
}

.productCollection_content {
  padding: 5px;
  position: relative;

  .productCollection_items_botton {
    border-bottom: 1px solid #eee;
  }

  .productCollection_items {
    color: rgb(88, 88, 88);
    display: flex;
    justify-content: space-between;
    width: calc(100% - 20px);
    margin: 0 auto;

    margin-top: 8px;

    .productCollection_index {
      font-size: 9pt;
      width: 10px;
      display: flex;
    }

    .productCollection_name {
      font-size: 10pt;
      width: 60%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .productCollection_count {
      font-size: 10pt;
    }

    .productCollection_price {
      color: red;
      // text-decoration: line-through;
    }
  }

  .productCollection_editcontent {
    position: absolute;
    bottom: 10px;
    right: 20px;
  }
}

.detail_params_items {
  width: calc(100% - 50px);
  margin: 0 auto;
  border-radius: 5px;
  width: 100%;
  margin: 5px;

  .detail_attributes_name,
  .detail_params_name {
    width: calc(100% - 70px);
    margin-left: 35px;
    font-size: 9pt;
    display: flex;
    justify-content: space-between;
    color: #807f7f;
  }
}
</style>
